import ManagedStaticPage from '../components/ManagedStaticPage';

export default function Privacy() {
  return <ManagedStaticPage slug="privacy" fallbackTitle="Privacy Policy" />;
}
